import { ColumnState, SortModelItem } from "ag-grid-community";

/**
 * Transforme un modèle de tri AG Grid en clause ORDER BY SQL.
 * @example sortModelToOrderBy([{ colId: "dvclCode", sort: "asc" }, { colId: "dvclDtprevu", sort: "desc" }])
 * // => "dvclCode asc, dvclDtprevu desc"
 */
export function sortModelToOrderBy(sortModel: SortModelItem[]): string {
  return sortModel
    .filter(({ colId }) => colId)
    .map(({ colId, sort }) => `${colId} ${sort ?? "asc"}`)
    .join(", ");
}

/**
 * Transforme une clause ORDER BY SQL en modèle de tri AG Grid.
 * L'ordre des clauses définit la priorité via `sortIndex` (0 = premier tri).
 * @example orderByToSortModel("dvclCode asc, dvclDtprevu desc")
 * // => [{ colId: "dvclCode", sort: "asc", sortIndex: 0 }, { colId: "dvclDtprevu", sort: "desc", sortIndex: 1 }]
 */
export function orderByToSortModel(orderBy: string): ColumnState[] {
  if (!orderBy.trim()) {
    return [];
  }

  return orderBy.split(",").reduce<ColumnState[]>((sortModel, clause) => {
    const parts = clause.trim().split(/\s+/);
    const rawColId = parts[0];
    if (!rawColId) {
      return sortModel;
    }

    const colId = rawColId.split(".")[0];
    const direction = (parts[1] ?? "asc").toLowerCase();
    sortModel.push({
      colId,
      sort: direction === "desc" ? "desc" : "asc",
      sortIndex: sortModel.length
    });
    return sortModel;
  }, []);
}
